<app-ngx-mat-table
  tableName="Content Table"
  description="Shows a table of all content and enables their manipulation."
  dataType="content"
  sortActive="content_id"
  [tableData]="tableData"
  [showActions]="showActions"
  (clickedButton)="clickedButton($event)"
  i18n-tableName
  i18n-description
></app-ngx-mat-table>
